import { normalizeDashboards } from '../../../../utils'
import { ensureUniqueObjectIds } from '@edge/spark/utils'
import { setActiveDashboardId, getActiveDashboardId } from '../../../../Stores'
import {
    ClientUserDashboardsDocument as query,
    type ClientUserDashboardsQuery,
    type MutationResolvers,
    UpdateUserDashboardsDocument as mutation,
    type UpdateUserDashboardsMutation,
} from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { getActiveAuctionId } from '@edge/spark/io-roles'

const deleteDashboard: MutationResolvers<ApolloResolverContext>['deleteDashboard'] = async (
    _root,
    { userId, dashId: subjectDashId },
    { client },
) => {
    console.debug('io-dashboards deleteDashboard Deprecated, refactor (soon)')

    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const priorActiveDashboardId = getActiveDashboardId()
    const dashId = subjectDashId || priorActiveDashboardId

    if (!dashId) {
        throw new Error('Missing DashId')
    }

    const auctionId = getActiveAuctionId()

    if (!auctionId) {
        throw new Error('deleteDashboard: Missing AuctionId')
    }

    const { data } = await client.query<ClientUserDashboardsQuery>({
        query,
        variables: { userId },
        fetchPolicy: 'network-only',
    })

    const savedDashboards = normalizeDashboards(data.dashboards)
    const updatedDashboards = savedDashboards.filter((d) => d.id !== dashId)

    // Set the active dashboard to the first dashboard if the active dashboard is deleted
    if (priorActiveDashboardId === dashId) {
        setActiveDashboardId(updatedDashboards[0]?.id)
    }

    const cleanedDashboards = ensureUniqueObjectIds(updatedDashboards)
    const stringifiedUpdatedDashboards = cleanedDashboards.map((d) => JSON.stringify(d))

    const admin = userId ? { auctionId, subjectUserId: userId } : undefined

    await client.mutate<UpdateUserDashboardsMutation>({
        mutation,
        variables: { admin, dashboards: stringifiedUpdatedDashboards },
        optimisticResponse: {
            updateUser: {
                __typename: 'UserMutationResponse',
                authenticationId: null,
                statusCode: 200,
                statusMessage: null,
            },
        },
    })

    return true
}

export default deleteDashboard
